import useTranslation from '@/utils/hooks/translation/useTranslation';
import useSubscription from '@/utils/hooks/swr/pricing/useSubscription';

import Button from '@/components/base/Button';
import Tooltip from '@/components/base/Tooltip';

export function PastDueButton() {
    const { t } = useTranslation('settings');
    const { subscription } = useSubscription();
    const isManualSubscription = subscription?.collection_mode === 'manual';

    const content = isManualSubscription ? 
        t('subscription_invoices_page.new_pricing.past_due_tooltip_manual') : 
        t('subscription_invoices_page.new_pricing.past_due_tooltip_auto');

    return (
        <Tooltip
            content={content}
            position="top">
            <span data-testid="past-due-button-wrapper">
                <Button
                    disabled
                    size="xl"
                    data-testid="button-change-plan-past-due"
                    className="w-full lg:w-max">
                    {t('subscription_invoices_page.change_your_plan')}
                </Button>
            </span>
        </Tooltip>
    );
}
